import { IconLayer } from '@deck.gl/layers';
import { Position3D } from 'deck.gl';

import mapPinRed from '@qfa/react-components/lib/components/images/mapPinRed.png';

const COLORS = ['red', 'orange', 'yellow', 'green', 'blue', 'purple'];
export function getRandomInRange(from: number, to: number, fixed: number) {
  return Number((Math.random() * (to - from) + from).toFixed(fixed));
}
export const getRandomLatLng = (): [number, number] => [
  getRandomInRange(48, 30, 6),
  getRandomInRange(-123, -74, 6),
];
export const getRandomColor = () => COLORS[getRandomInRange(0, 5, 0)];

type LocationMarkerType = {
  coordinates: Position3D;
  name: string;
};

export const getLocationMarkerLayer = (coordinates: number[]): IconLayer<LocationMarkerType> => {
  return new IconLayer<LocationMarkerType>({
    id: 'marker-layer',
    data: [{ name: 'marker', coordinates: coordinates as Position3D }],
    iconAtlas: mapPinRed,
    getPosition: (x: LocationMarkerType) => x.coordinates,
    getIcon: () => 'marker',
    getSize: 38,
    pickable: true,
    iconMapping: {
      marker: {
        x: 0,
        y: 0,
        width: 29,
        height: 38,
        anchorY: 38,
      },
    },
  });
};
